import { Modal } from 'antd';
import styled from 'styled-components';

const ModalSuccessBookingStyled = styled(Modal)`
    max-width: 430px !important;
    width: 100% !important;
    top: 0px !important;
    padding: 0 !important;
    margin: auto !important;
    border-radius: unset;
    height: 100vh;
    max-height: 100vh;

    .ant-modal-content {
        border-radius: unset;
        height: 100vh;
        max-height: 100vh;
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom) 0;
    }

    .ant-modal-body {
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        border-radius: unset;
        height: 100%;
        max-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
        overflow-y: auto;
        padding: 24px 16px;
        padding-bottom: calc(24px + env(safe-area-inset-bottom));
        box-sizing: border-box;

        .image-verified {
            display: flex;
            justify-content: center;
            flex-shrink: 0;
        }
        .booking-info {
            margin-bottom: -20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            background-color: var(--primary-color);
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            .ant-typography {
                color: white;
            }
        }

        .booking-info-detail {
            display: flex;
            flex-direction: column;
            row-gap: 16px;
        }
    }

    @media (max-width: 480px) {
        max-width: 100% !important;
    }
`;

export default ModalSuccessBookingStyled;
